export enum SENTRY_FEATURE_TAGS {
  Asset = 'asset',
  Product = 'product',
  Collection = 'collection',
  CsvDownload = 'csv_download',
  Authentication = 'authentication',
  Organization = 'organization',
  Api = 'api',
  Navigation = 'navigation',
}

export const SENTRY_STAGE_TAGS = {
  [SENTRY_FEATURE_TAGS.Authentication]: {
    loginUser: 'login_user',
    logout: 'logout',
    setPassword: 'set_password',
    removeAuthentication: 'remove_authentication',
    reauthenticate: 'reauthenticate',
    notAuthenticated: 'not_authenticated',
    localStorage: 'local_storage',
    exchangeToken: 'exchange_token',
  },
  [SENTRY_FEATURE_TAGS.Organization]: {
    createOrganization: 'create_organization',
    createOrganizationDataRecord: 'create_organization_data_record',
    addUserToOrganization: 'add_user_to_organization',
    associateIcpProductCategories: 'associate_icp_product_categories',
    associateRetailerRegions: 'associate_retailer_regions',
  },
  [SENTRY_FEATURE_TAGS.Asset]: {
    assetUpload: 'asset_upload',
    assetDataRecordCreation: 'asset_data_record_creation',
    assetS3Upload: 'asset_s3_upload',
    assetSparksGeneration: 'asset_sparks_generation',
    assetImageGeneration: 'asset_image_generation',
    assetPolling: 'asset_polling',
  },
  [SENTRY_FEATURE_TAGS.Product]: {
    productImport: 'product_import',
    bulkImport: 'bulk_import',
    productCreate: 'product_create',
    productDelete: 'product_delete',
    productAssetsPolling: 'product_assets_polling',
    productAssetUpload: 'product_asset_upload',
    productAssetS3Upload: 'product_asset_s3_upload',
    productGoToLive: 'product_go_to_live',
    productRecommendationsPolling: 'product_recommendations_polling',
    productDataPolling: 'product_data_polling',
    productCarouselImagesPolling: 'product_carousel_images_polling',
    productCarouselReorder: 'product_carousel_reorder',
    productDragAndDrop: 'product_drag_and_drop',
    productNewProductUpdate: 'product_new_product_update',
  },
  [SENTRY_FEATURE_TAGS.Collection]: {
    collectionCreate: 'collection_create',
    collectionUpdate: 'collection_update',
    collectionAssetUpload: 'collection_asset_upload',
    collectionAssetPolling: 'collection_asset_polling',
  },
  [SENTRY_FEATURE_TAGS.CsvDownload]: {
    products: 'products',
  },
  [SENTRY_FEATURE_TAGS.Navigation]: {
    breadcrumbs: 'breadcrumbs',
  },
} as const;
